module.exports = __webpack_public_path__ + "static/media/HCMM774.ddc8e4fc.jpg";